export enum PICKUP_STATUS {
  DONE = 'DONE',
  PENDING = 'PENDING',
  ALL = 'ALL',
}
